import app from 'flarum/forum/app';

/**
 * Right-sized, modern-format copies of our R2 images, made by Cloudflare Image
 * Transformations (`/cdn-cgi/image/...` on the site's own hostname) so the
 * origin never resizes or serves them.
 *
 * Only `https://uploads.blizznux.com/covers/` is rewritten: Cloudflare can
 * fetch it, and `onerror=redirect` falls back to the original when it can't,
 * which only works for a source on the same zone. Anything else (the logo
 * stand-in, a member's image) is left alone.
 *
 * The widths are a fixed set, so a cover has at most WIDTHS.length variants and
 * the Free plan's 5,000 unique transformations a month stay far away.
 *
 * Kill switch: the `blizznux-home.cf_images` setting. Off, or absent, and
 * every URL is the original.
 */
const WIDTHS = [320, 640, 960];
const SOURCE = /^https:\/\/uploads\.blizznux\.com\/covers\//;
const enabled = () => !!app.forum.attribute('blizznuxCfImages');
const variant = (url, width) => '/cdn-cgi/image/width=' + width + ',format=auto,onerror=redirect/' + url;

/** `src`, `srcset` and `sizes` for an <img>; `sizes` is the layout's slot. */
export function cdnImage(url, sizes) {
  if (!enabled() || !SOURCE.test(url)) return {
    src: url
  };
  return {
    src: variant(url, 640),
    srcset: WIDTHS.map(w => variant(url, w) + ' ' + w + 'w').join(', '),
    sizes
  };
}
flarum.reg.add('blizznux-home', 'forum/components/cdnImage', { cdnImage: cdnImage, });